import PropTypes from 'prop-types';
import React from 'react';
import Portal from 'common/components/Portal';
import Viewport from 'common/utils/Viewport';
import classNames from 'classnames';
import { getOffset } from 'common/utils/boxPosition';

export default class Tooltip extends React.Component {
    constructor(props) {
        super(props);

        // Set default values that are updated during positioning.
        this.state = {
            width: 0,
            height: 0,
            relLeft: 0,
            relTop: 0,
            relWidth: 0,
            tipWidth: 0,
            tipHeight: 0,
        };
    }

    positionRelativeTo(element, cb) {
        let tooltip = this.refs.tooltip;
        let tip = this.refs.tip;
        let offset = getOffset(element);

        this.setState(
            {
                width: tooltip.offsetWidth,
                height: tooltip.offsetHeight,
                relLeft: offset.left,
                relTop: offset.top,
                relWidth: element.offsetWidth,
                tipWidth: tip.offsetWidth,
                tipHeight: tip.offsetHeight,
            },
            cb
        );
    }

    getCenteredStyle() {
        return {
            left: this.state.relLeft + this.state.relWidth / 2 - this.state.width / 2,
            top: this.state.relTop - (this.state.height + this.state.tipHeight + this.props.offset),
            textAlign: this.props.alignText,
            maxWidth: this.props.maxWidth,
        };
    }

    getResponsiveStyle() {
        return {
            top: this.state.relTop - (this.state.height + this.state.tipHeight),
            textAlign: 'center',
            left: 10,
            right: 10,
        };
    }

    getResponsiveTipStyle() {
        return {
            left: this.state.relLeft + this.state.relWidth / 2 - this.state.tipWidth,
            marginLeft: -1 * (this.state.tipWidth / 4),
        };
    }

    render() {
        let location = 'up-center';
        let state = this.props.visible ? 'active' : 'inactive';
        let boxStyle = {};
        let tipStyle = {};

        if (!this.context.viewport.inSize(['small'])) {
            boxStyle = this.getCenteredStyle();
        } else {
            boxStyle = this.getResponsiveStyle();
            tipStyle = this.getResponsiveTipStyle();
        }

        const classes = classNames(
            'tooltip',
            this.props.variations.map(varation => `tooltip--${varation}`)
        );

        return (
            <Portal>
                <div
                    ref="tooltip"
                    className={classes}
                    style={boxStyle}
                    data-tooltip-state={state}
                    data-tooltip-location={location}
                >
                    <div className="tooltip__tip" ref="tip" style={tipStyle} />
                    <div className="tooltip__content">{this.props.children}</div>
                </div>
            </Portal>
        );
    }
}

Tooltip.contextTypes = {
    viewport: PropTypes.instanceOf(Viewport),
    variations: PropTypes.array,
};

Tooltip.defaultProps = {
    maxWidth: 0,
    alignText: 'center',
    offset: 0,
    variations: [],
};
